// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("@assets/shop/daily_bg_idle.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("@assets/shop/daily_bg_active.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("@assets/shop/daily_title_bar.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("@assets/shop/daily_button.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dailyLootContainer {
    max-width: 1024px;
    margin: auto;
}

.dailyLoots {
    display: flex;
    justify-content: center;
    gap: 50px;
    width: 100%;
}

.lootBoxContainer {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: 100% 100%;
    padding: 10px 8px;
    width: 184px;
    height: 198px;
    cursor: pointer;
}

.lootBoxContainer:hover {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.loot-box-image {
    width: 108px;
    height: 84px;
}

.loot-box-title {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    background-size: 100% 100%;
    width: 86%;
    padding: 8px;
    text-align: center;
    text-transform: uppercase;
    font-size: 12px;
    font-weight: 600;
    color: #FFFFFF;
}

.loot-box-footer {
    color: #FFFFFF;
    font-weight: 400;
    font-size: 12px;
    text-transform: uppercase;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
    background-size: 100% 100%;
    width: 96%;
    margin-bottom: 2px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
    height: 36px;
}

.loot-box-footer span {
    font-weight: 600;
}

.loot-box-footer img {
    width: 16px;
    height: 16px;
    vertical-align: middle;
}

.loot-box-countdown {
    color: #a0d937;
    margin-left: 3px;
}

.loot-box-key {
    margin-left: 8px;
}

.loot-box-footer .loot-box-open {
    font-weight: 800;
    font-size: 18px;
    color: #ffb653;
    text-shadow: 0px 0px 16px #ef8056;
}

@keyframes shake {
    0% { transform: rotate(0deg); }
    25% { transform: rotate(15deg); }
    50% { transform: rotate(-15deg); }
    75% { transform: rotate(15deg); }
    100% { transform: rotate(0deg); }
  }
  
  /* Example usage in CSS classes if preferred over inline styles */
  .shake-animation {
    animation: shake 0.5s infinite;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/dailyLoot/DailyLoot.style.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,yDAAuD;IACvD,0BAA0B;IAC1B,iBAAiB;IACjB,YAAY;IACZ,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,yDAAyD;AAC7D;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,yDAAyD;IACzD,0BAA0B;IAC1B,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,yDAAsD;IACtD,0BAA0B;IAC1B,UAAU;IACV,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,iCAAiC;AACrC;;AAEA;IACI,KAAK,uBAAuB,EAAE;IAC9B,MAAM,wBAAwB,EAAE;IAChC,MAAM,yBAAyB,EAAE;IACjC,MAAM,wBAAwB,EAAE;IAChC,OAAO,uBAAuB,EAAE;EAClC;;EAEA,iEAAiE;EACjE;IACE,8BAA8B;EAChC","sourcesContent":[".dailyLootContainer {\n    max-width: 1024px;\n    margin: auto;\n}\n\n.dailyLoots {\n    display: flex;\n    justify-content: center;\n    gap: 50px;\n    width: 100%;\n}\n\n.lootBoxContainer {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    background-image: url('@assets/shop/daily_bg_idle.png');\n    background-size: 100% 100%;\n    padding: 10px 8px;\n    width: 184px;\n    height: 198px;\n    cursor: pointer;\n}\n\n.lootBoxContainer:hover {\n    background-image: url('@assets/shop/daily_bg_active.png');\n}\n\n.loot-box-image {\n    width: 108px;\n    height: 84px;\n}\n\n.loot-box-title {\n    background-image: url('@assets/shop/daily_title_bar.png');\n    background-size: 100% 100%;\n    width: 86%;\n    padding: 8px;\n    text-align: center;\n    text-transform: uppercase;\n    font-size: 12px;\n    font-weight: 600;\n    color: #FFFFFF;\n}\n\n.loot-box-footer {\n    color: #FFFFFF;\n    font-weight: 400;\n    font-size: 12px;\n    text-transform: uppercase;\n    background-image: url('@assets/shop/daily_button.png');\n    background-size: 100% 100%;\n    width: 96%;\n    margin-bottom: 2px;\n    text-align: center;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 8px;\n    height: 36px;\n}\n\n.loot-box-footer span {\n    font-weight: 600;\n}\n\n.loot-box-footer img {\n    width: 16px;\n    height: 16px;\n    vertical-align: middle;\n}\n\n.loot-box-countdown {\n    color: #a0d937;\n    margin-left: 3px;\n}\n\n.loot-box-key {\n    margin-left: 8px;\n}\n\n.loot-box-footer .loot-box-open {\n    font-weight: 800;\n    font-size: 18px;\n    color: #ffb653;\n    text-shadow: 0px 0px 16px #ef8056;\n}\n\n@keyframes shake {\n    0% { transform: rotate(0deg); }\n    25% { transform: rotate(15deg); }\n    50% { transform: rotate(-15deg); }\n    75% { transform: rotate(15deg); }\n    100% { transform: rotate(0deg); }\n  }\n  \n  /* Example usage in CSS classes if preferred over inline styles */\n  .shake-animation {\n    animation: shake 0.5s infinite;\n  }\n  "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
